export default "__VITE_ASSET__zJ0w_eB2__"